import React from 'react';
import { OptionRow } from '../../ui/OptionRow';
import { asDraft } from '../../../types/registration';
import { AFFILIATION_OPTIONS } from '../../../data/registration';
import type { QuestionProps } from './types';
export function ConnectionQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  return <div role="radiogroup" aria-label="How you were connected" className="flex flex-col gap-2.5" data-id="element-438" data-mp="oicxueh6pbvx">
      {AFFILIATION_OPTIONS.map(option => <OptionRow key={option.value} title={option.label} selected={draft.affiliationType === option.value} onSelect={() => update({
      affiliationType: option.value
    })} data-id="element-439" data-mp="ekyg8bjiyh21" />)}
    </div>;
}